import { createBrowserRouter, Outlet } from "react-router-dom";
import Login from "./pages/Admin/Login/_Login";
import LoginLinkRequest from "./pages/Admin/LoginLinkRequest/_LoginLinkRequest";
import LoginLinkConfirmation from "./pages/Admin/LoginLinkConfirmation/_LoginLinkConfirmation";
import Logout from "./pages/Admin/Logout/_Logout";
import Dashboard from "./pages/Dashboard/_Dashboard";
import ActivityHistory from "./pages/Admin/ActivityHistory/_ActivityHistory";
import Lists from "./pages/Admin/Lists/_Lists";
import Notes from "./pages/Admin/Notes/_Notes";
import PageLayout, {
  GateKeeperPageLayout,
  PIS75GateKeeperPageLayout,
  FlexAccessLayout,
  BrandedLoginLayout,
  DeepLinkingRedirectLayout,
} from "./pages/_Layouts/PageLayout";
import PeopleReport from "./pages/Reports/PeopleReport/_PeopleReport";
import PeopleSearch from "./pages/Reports/PeopleSearch/_PeopleSearch";
import SocialReport from "./pages/Reports/SocialReport/_SocialReport";
import SocialHome from "./pages/Reports/SocialHome/_SocialHome";
import PropertyReport from "./pages/Reports/PropertyReport/_PropertyReport";
import MyAccount from "./pages/Admin/MyAccount/_MyAccount";
import ManageMembership from "./pages/Admin/CancelFunnels/BlueSnapCancelFunnel/1_ManageMembership";
import CancelMembership from "./pages/Admin/CancelFunnels/DefaultCancelFunnel/1_CancelMembership";
import CancelOptions from "./pages/Admin/CancelFunnels/DefaultCancelFunnel/3_CancelOptions";
import CancelConfirmation from "./pages/Admin/CancelFunnels/CancelConfirmation";
import OfferConfirmation from "./pages/Admin/CancelFunnels/OfferConfirmation";
import CancelFeedback from "./pages/Admin/CancelFunnels/DefaultCancelFunnel/2_CancelFeedback";
import PhoneReport from "./pages/Reports/PhoneReport/_PhoneReport";
import TestPullPhoneReport from "./components/UtilComponents/TEST_PullPhoneReport";
import TestPullPeopleReport from "./components/UtilComponents/TEST_PullPeopleReport";
import TestPullSocialReport from "./components/UtilComponents/TEST_PullSocialReport";
import ResetPassword from "./pages/Admin/ResetPassword/_ResetPassword";
import NewPassword from "./pages/Admin/NewPassword/_NewPassword";
import TestPullPropertyReport from "./components/UtilComponents/TEST_PullPropertyReport";
import AuthSyncFromLink from "./components/UtilComponents/AUTH_SyncFromLink";
import UpdateCreditCard from "./pages/Admin/UpdateCreditCard/_UpdateCreditCard";
import VehicleReport from "./pages/Reports/VehicleReport/_VehicleReport";
import NotSupported from "./pages/Admin/NotSupported/_NotSupported";
import TestPullVehicleReport from "./components/UtilComponents/TEST_PullVehicleReport";
import IdProtect from "./pages/Admin/IdProtect/_IdProtect";
import VerifyEmail from "./pages/Admin/EmailVerified/_EmailVerified";
import NeighborhoodReport from "./pages/Reports/NeighborhoodReport/_NeighborhoodReport";
import NeighborhoodSearch from "./pages/Reports/NeighborhoodSearch/_NeighborhoodSearch";
import TestPullNeighborhoodReport from "./components/UtilComponents/TEST_PullNeighborhoodReport";
import TestPullNeighborhoodSearch from "./components/UtilComponents/TEST_PullNeighborhoodSearch";
import TestError from "./pages/TestError/_TestError";
import LoadTestError from "./pages/TestError/_LoadTestError";
import ErrorPage from "./pages/Admin/ErrorPage/ErrorPage";
import PhoneHome from "./pages/Reports/PhoneHome/_PhoneHome";
import PropertyHome from "./pages/Reports/PropertyHome/_PropertyHome";
import PeopleHome from "./pages/Reports/PeopleHome/_PeopleHome";
import NeighborhoodHome from "./pages/Reports/NeighborhoodHome/_NeighborhoodHome";
import VehicleHome from "./pages/Reports/VehicleHome/_VehicleHome";
import AccountPaused from "./pages/Admin/AccountPaused/AccountPaused";
import TestGrabNewState from "./components/UtilComponents/TEST_GrabNewState";
import MarketSearch from "./pages/Reports/MarketSearch/_MarketSearch";
import SearchResults from "./pages/Admin/ProfileProtection/_SearchResults";
import ScanExposures from "./pages/Admin/ProfileProtection/_ScanExposures";
import InfoCollection from "./pages/Admin/ProfileProtection/_InfoCollection";
import Verification from "./pages/Admin/ProfileProtection/_Verification";
import RemoveFromView from "./pages/Admin/ProfileProtection/_RemoveFromView";
import StartRemovals from "./pages/Admin/ProfileProtection/_StartRemovals";
import StatusHub from "./pages/Admin/ProfileProtection/_StatusHub";
import EmailsPreview from "./pages/Admin/ProfileProtection/_EmailsPreview";

const router = createBrowserRouter([
  {
    path: "/",
    errorElement: (
      <PageLayout pageName="error" documentTitle="Error Occurred" header>
        <ErrorPage />
      </PageLayout>
    ),
    element: <Outlet />,
    children: [
      {
        path: "/",
        element: (
          <GateKeeperPageLayout
            pageName="dashboard"
            documentTitle="Access Your Personalized Member Account"
            header
            displayButtons
          >
            <Dashboard />
          </GateKeeperPageLayout>
        ),
      },
      {
        path: "/people-home",
        element: (
          <GateKeeperPageLayout
            pageName="people-home"
            documentTitle="People Home"
            header
            displayButtons
          >
            <PeopleHome />
          </GateKeeperPageLayout>
        ),
      },
      {
        path: "/people-search",
        element: (
          <GateKeeperPageLayout
            pageName="people-search"
            documentTitle="People Search"
            header
            displayButtons
            includeDeactivateBanner={false}
            includeReactivateBanner={false}
          >
            <PeopleSearch />
          </GateKeeperPageLayout>
        ),
      },
      {
        path: "/people-report",
        element: (
          <GateKeeperPageLayout
            pageName="people-report"
            documentTitle="People Report"
            header
            displayButtons
            includeDeactivateBanner={false}
            includeReactivateBanner={false}
          >
            <PeopleReport />
          </GateKeeperPageLayout>
        ),
        children: [],
      },
      {
        path: "/people-report/:reportToken",
        element: (
          <GateKeeperPageLayout
            pageName="people-report-test"
            documentTitle="People Report Test Route"
            header
            displayButtons
            includeDeactivateBanner={false}
            includeReactivateBanner={false}
          >
            <TestPullPeopleReport />
          </GateKeeperPageLayout>
        ),
      },
      {
        path: "/social-report",
        element: (
          <GateKeeperPageLayout
            pageName="social-report"
            documentTitle="Social Report"
            header
            displayButtons
            includeDeactivateBanner={false}
            includeReactivateBanner={false}
          >
            <SocialReport />
          </GateKeeperPageLayout>
        ),
      },
      {
        path: "/social-report/:social",
        element: (
          <GateKeeperPageLayout
            pageName="social-report-test"
            documentTitle="Social Report Test Route"
            header
            displayButtons
            includeDeactivateBanner={false}
            includeReactivateBanner={false}
          >
            <TestPullSocialReport />
          </GateKeeperPageLayout>
        ),
      },
      {
        path: "/social-home",
        element: (
          <GateKeeperPageLayout
            pageName="social-home"
            documentTitle="Social Homepage"
            header
            displayButtons
          >
            <SocialHome />
          </GateKeeperPageLayout>
        ),
      },
      {
        path: "/property-home",
        element: (
          <GateKeeperPageLayout
            pageName="property-home"
            documentTitle="Property Home"
            header
            displayButtons
          >
            <PropertyHome />
          </GateKeeperPageLayout>
        ),
      },
      {
        path: "/property-report",
        element: (
          <GateKeeperPageLayout
            pageName="property-report"
            documentTitle="Property Report"
            header
            displayButtons
            includeDeactivateBanner={false}
            includeReactivateBanner={false}
          >
            <PropertyReport />
          </GateKeeperPageLayout>
        ),
      },
      {
        path: "/property-report/test",
        element: (
          <GateKeeperPageLayout
            pageName="property-report-test"
            documentTitle="Property Report Test Route"
            header
            displayButtons
            includeDeactivateBanner={false}
            includeReactivateBanner={false}
          >
            <TestPullPropertyReport />
          </GateKeeperPageLayout>
        ),
      },

      {
        path: "/phone-home",
        element: (
          <GateKeeperPageLayout
            pageName="phone-home"
            documentTitle="Phone Home"
            header
            displayButtons
          >
            <PhoneHome />
          </GateKeeperPageLayout>
        ),
      },
      {
        path: "/phone-report",
        element: (
          <GateKeeperPageLayout
            pageName="phone-report"
            documentTitle="Phone Report"
            header
            displayButtons
            includeDeactivateBanner={false}
            includeReactivateBanner={false}
          >
            <PhoneReport />
          </GateKeeperPageLayout>
        ),
      },
      {
        path: "/phone-report/:phoneNumber",
        element: (
          <GateKeeperPageLayout
            pageName="phone-report-test"
            documentTitle="Phone Report Test Route"
            header
            displayButtons
            includeDeactivateBanner={false}
            includeReactivateBanner={false}
          >
            <TestPullPhoneReport />
          </GateKeeperPageLayout>
        ),
      },
      {
        path: "/authx/:uuid",
        element: (
          <PageLayout pageName="auth-x" documentTitle="CrossAuthentication">
            <AuthSyncFromLink />
          </PageLayout>
        ),
      },
    ],
  },
  {
    path: "/test-error",
    errorElement: <div>ERROR</div>,
    element: (
      <GateKeeperPageLayout
        pageName="test-error"
        documentTitle="Error"
        header
        displayButtons
      >
        <TestError />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/onload-test-error",
    errorElement: <div>ERROR</div>,
    element: (
      <GateKeeperPageLayout
        pageName="onload-test-error"
        documentTitle="Error"
        header
        displayButtons
      >
        <LoadTestError />
      </GateKeeperPageLayout>
    ),
  },
  /* Vehicle Report */
  {
    path: "/vehicle-report",
    element: (
      <GateKeeperPageLayout
        pageName="vehicle-report"
        documentTitle="Vehicle Report"
        header
        displayButtons
        includeDeactivateBanner={false}
        includeReactivateBanner={false}
      >
        <VehicleReport />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/vehicle-report/:vin",
    element: (
      <GateKeeperPageLayout
        pageName="vehicle-report-test"
        documentTitle="Vehicle Report"
        header
        displayButtons
        includeDeactivateBanner={false}
        includeReactivateBanner={false}
      >
        <TestPullVehicleReport />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/vehicle-home",
    element: (
      <GateKeeperPageLayout
        pageName="vehicle-home"
        documentTitle="Vehicle Home"
        header
        displayButtons
      >
        <VehicleHome />
      </GateKeeperPageLayout>
    ),
  },
  /* Neighborhood Report */
  {
    path: "/neighborhood-home",
    element: (
      <GateKeeperPageLayout
        pageName="neighborhood-home"
        documentTitle="Neighborhood Home"
        header
        displayButtons
      >
        <NeighborhoodHome />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/neighborhood-report",
    element: (
      <GateKeeperPageLayout
        pageName="neighborhood-report"
        documentTitle="Neighborhood Report"
        header
        displayButtons
        includeDeactivateBanner={false}
        includeReactivateBanner={false}
      >
        <NeighborhoodReport />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/neighborhood-report/test",
    element: (
      <GateKeeperPageLayout
        pageName="neighborhood-report-test"
        documentTitle="Neighborhood Report Test Route"
        header
        displayButtons
        includeDeactivateBanner={false}
        includeReactivateBanner={false}
      >
        <TestPullNeighborhoodReport />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/neighborhood-search",
    element: (
      <GateKeeperPageLayout
        pageName="neighborhood-watch-search"
        documentTitle="Neighborhood Watch Search"
        header
        displayButtons
        includeDeactivateBanner={false}
        includeReactivateBanner={false}
      >
        <NeighborhoodSearch />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/neighborhood-search/test",
    element: (
      <GateKeeperPageLayout
        pageName="neighborhood-search-test"
        documentTitle="Neighborhood Search Test Route"
        header
        displayButtons
        includeDeactivateBanner={false}
        includeReactivateBanner={false}
      >
        <TestPullNeighborhoodSearch />
      </GateKeeperPageLayout>
    ),
  },
  /* Market Search */
  {
    path: "/market-search",
    element: (
      <GateKeeperPageLayout
        pageName="market-search"
        documentTitle="Market Search"
        header
        displayButtons
        includeDeactivateBanner={false}
        includeReactivateBanner={false}
      >
        <MarketSearch />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/consult-the-codex-astartes",
    element: (
      <GateKeeperPageLayout
        pageName="grab-new-state-test"
        documentTitle="Grab New State Test"
        header
        displayButtons
      >
        <TestGrabNewState />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/login",
    element: (
      <BrandedLoginLayout
        pageName="login"
        documentTitle="Secure Login Portal for Members"
        includeDeactivateBanner={false}
        includeReactivateBanner={false}
      >
        <Login />
      </BrandedLoginLayout>
    ),
  },
  {
    path: "/login-link-request",
    element: (
      <BrandedLoginLayout
        pageName="login-link"
        documentTitle="One Time Login Link"
        includeDeactivateBanner={false}
        includeReactivateBanner={false}
      >
        <LoginLinkRequest />
      </BrandedLoginLayout>
    ),
  },
  {
    path: "/login-link-request/confirmation",
    element: (
      <BrandedLoginLayout
        pageName="login-link-confirmation"
        documentTitle="One Time Login Link Confirmation"
        includeDeactivateBanner={false}
        includeReactivateBanner={false}
      >
        <LoginLinkConfirmation />
      </BrandedLoginLayout>
    ),
  },
  {
    path: "/logout",
    element: (
      <PageLayout
        pageName="logout"
        header
        documentTitle="Logout"
        footerType="min-footer"
        minFooterOptions={{ color: "base" }}
        includeDeactivateBanner={false}
        includeReactivateBanner={false}
      >
        <Logout />
      </PageLayout>
    ),
  },
  {
    path: "/not-supported",
    element: (
      <PageLayout
        pageName="not-supported"
        documentTitle="NotSupported"
        footerType="min-footer"
        minFooterOptions={{ color: "white" }}
      >
        <NotSupported />
      </PageLayout>
    ),
  },
  {
    path: "/activity-history",
    element: (
      <GateKeeperPageLayout
        pageName="activity-history"
        header
        documentTitle="Activity History"
        displayButtons
      >
        <ActivityHistory />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/lists",
    element: (
      <GateKeeperPageLayout
        pageName="lists"
        header
        documentTitle="Lists Page"
        displayButtons
      >
        <Lists />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/your-notes",
    element: (
      <GateKeeperPageLayout
        pageName="notes"
        header
        documentTitle="Your Notes Page"
        displayButtons
      >
        <Notes />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/my-account",
    element: (
      <DeepLinkingRedirectLayout
        pageName="my-account"
        header
        documentTitle="Login Your Account"
        displayButtons
        logMemberEvent
      >
        <MyAccount />
      </DeepLinkingRedirectLayout>
    ),
  },
  // Default Cancel Funnel
  {
    path: "/cancel-membership",
    element: (
      <GateKeeperPageLayout
        pageName="cancel-membership"
        header
        documentTitle="Cancel Membership"
        displayButtons
        logMemberEvent
      >
        <CancelMembership />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/cancel-feedback",
    element: (
      <GateKeeperPageLayout
        pageName="cancel-feedback"
        header
        documentTitle="Cancel Feedback"
        displayButtons
        logMemberEvent
      >
        <CancelFeedback />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/cancel-options",
    element: (
      <GateKeeperPageLayout
        pageName="cancel-options"
        header
        documentTitle="Cancel Options"
        displayButtons
        logMemberEvent
      >
        <CancelOptions />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/offer-confirmation",
    element: (
      <GateKeeperPageLayout
        pageName="offer-confirmation"
        header
        documentTitle="Offer Confirmation"
        displayButtons
        logMemberEvent
      >
        <OfferConfirmation />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/cancel-confirmation",
    element: (
      <GateKeeperPageLayout
        pageName="cancel-confirmation"
        header
        documentTitle="Cancel Confirmation"
        logMemberEvent
        includeDeactivateBanner={false}
        includeReactivateBanner={false}
      >
        <CancelConfirmation />
      </GateKeeperPageLayout>
    ),
  },
  // BlueSnap Cancel Funnel
  {
    path: "/manage-membership",
    element: (
      <GateKeeperPageLayout
        pageName="manage-membership"
        header
        documentTitle="Manage Membership"
        displayButtons
        logMemberEvent
      >
        <ManageMembership />
      </GateKeeperPageLayout>
    ),
  },
  {
    path: "/about",
    element: (
      <GateKeeperPageLayout pageName="about" header documentTitle="About">
        <Outlet />
      </GateKeeperPageLayout>
    ),
    children: [
      {
        path: "/about/",
        element: <div>About index page</div>,
      },
      {
        path: "/about/:id",
        element: <div>Id</div>,
      },
    ],
  },
  {
    path: "/reset-password",
    element: (
      <FlexAccessLayout
        pageName="reset-password"
        header
        documentTitle="Recover or Reset Your Account Password"
        displayButtons
      >
        <ResetPassword />
      </FlexAccessLayout>
    ),
  },
  {
    path: "/new-password",
    element: (
      <FlexAccessLayout
        pageName="new-password"
        header
        documentTitle="New Password"
        displayButtons
      >
        <NewPassword />
      </FlexAccessLayout>
    ),
  },
  {
    path: "/update-credit-card",
    element: (
      <DeepLinkingRedirectLayout
        pageName="update-credit-card"
        header
        documentTitle="Update Credit Card"
        displayButtons
      >
        <UpdateCreditCard />
      </DeepLinkingRedirectLayout>
    ),
  },
  {
    path: "/email-verified",
    element: (
      <DeepLinkingRedirectLayout
        pageName="email-verified"
        header
        documentTitle="Email Verified"
        displayButtons
      >
        <VerifyEmail />
      </DeepLinkingRedirectLayout>
    ),
  },
  {
    path: "*",
    element: (
      <PageLayout pageName="not-found" documentTitle="404 Not Found" header>
        <ErrorPage />
      </PageLayout>
    ),
  },
  {
    path: "/id-protect",
    element: (
      <DeepLinkingRedirectLayout
        pageName="id-protect"
        documentTitle="Id Protect"
        header
        displayButtons
      >
        <IdProtect />
      </DeepLinkingRedirectLayout>
    ),
  },
  {
    path: "/account-paused",
    element: (
      <DeepLinkingRedirectLayout
        pageName="account-paused"
        documentTitle="Account Paused"
        header
      >
        <AccountPaused />
      </DeepLinkingRedirectLayout>
    ),
  },
  {
    path: "/protection/search",
    element: (
      <PIS75GateKeeperPageLayout
        pageName="protection-search"
        documentTitle="Protection Search"
        header
        displayButtons
      >
        <SearchResults />
      </PIS75GateKeeperPageLayout>
    ),
  },
  {
    path: "/protection/scan",
    element: (
      <PIS75GateKeeperPageLayout
        pageName="protection-scan"
        documentTitle="Scan Exposures"
        header
        displayButtons
      >
        <ScanExposures />
      </PIS75GateKeeperPageLayout>
    ),
  },
  {
    path: "/protection/info",
    element: (
      <PIS75GateKeeperPageLayout
        pageName="protection-info"
        documentTitle="Confirm Details"
        header
        displayButtons
      >
        <InfoCollection />
      </PIS75GateKeeperPageLayout>
    ),
  },
  {
    path: "/protection/verify",
    element: (
      <PIS75GateKeeperPageLayout
        pageName="protection-verify"
        documentTitle="Verify Email"
        header
        displayButtons
      >
        <Verification />
      </PIS75GateKeeperPageLayout>
    ),
  },
  {
    path: "/protection/remove",
    element: (
      <PIS75GateKeeperPageLayout
        pageName="protection-remove"
        documentTitle="Remove From View"
        header
        displayButtons
      >
        <RemoveFromView />
      </PIS75GateKeeperPageLayout>
    ),
  },
  {
    path: "/protection/confirm",
    element: (
      <PIS75GateKeeperPageLayout
        pageName="protection-confirm"
        documentTitle="Start Removals"
        header
        displayButtons
      >
        <StartRemovals />
      </PIS75GateKeeperPageLayout>
    ),
  },
  {
    path: "/protection/status",
    element: (
      <PIS75GateKeeperPageLayout
        pageName="protection-status"
        documentTitle="Protection Status"
        header
        displayButtons
      >
        <StatusHub />
      </PIS75GateKeeperPageLayout>
    ),
  },
  {
    path: "/protection/emails",
    element: (
      <PIS75GateKeeperPageLayout
        pageName="protection-emails"
        documentTitle="Email Previews"
        header
        displayButtons
      >
        <EmailsPreview />
      </PIS75GateKeeperPageLayout>
    ),
  },
]);

export default router;
